import React, { useCallback } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { AccountType, ResultObjectType, SystemAccountType } from '@cbgms/api'
import FullName from '@cbgms/components/src/utils/FullName'
import { ResultTitle } from './Title'
import { manufacturerToClass } from '@cbgms/components/src/utils/vehicle'
import Icon from '@mui/material/Icon'
import LicensePlate from '@cbgms/components/form/LicensePlate'
import { VinText } from '@carsys/ui'
import { AccountIcon } from '@cbgms/components/src/utils/AccountIcon'

const useStyles = makeStyles(() =>
  createStyles({
    pointer: {
      width: '100%',
      cursor: 'pointer'
    }
  })
)

export interface WorkorderResultType {
  Type: ResultObjectType
  WorkOrder: WorkOrderProps
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

interface WorkOrderProps {
  CustomerSystemType: SystemAccountType
  CustomerType: AccountType
  CustomerFirstName: string
  CustomerName: string
  CustomerPrefix: string
  CreatedAt: string
  ID: string
  UUID: string
  VehicleManufacturer: string
  VehicleModel: string
  VehicleRegistration: string
  VehicleType: string
  VehicleVIN: string
}
const gridSize = { workorderCell: 12 }
export const WorkOrderResult: React.FC<WorkorderResultType> = props => {
  const { WorkOrder, Type, hasGroupHeader, primaryAction } = props
  const classes = useStyles()
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )
  return (
    <div className={classes.pointer} onClick={onClick}>
      <Grid container spacing={2}>
        <ResultTitle resultType={Type} isTitleVisible={!hasGroupHeader} />
        <Grid item xs={gridSize.workorderCell} display='flex' flexWrap='wrap'>
          <Box flex='1 1 auto' sx={{ verticalAlign: 'middle' }}>
            <Typography variant='body1' component='h3' sx={{ fontWeight: 'bold', display: 'inline-block', marginRight: 2 }}>
              {WorkOrder.ID}
            </Typography>
            {WorkOrder?.CustomerName && WorkOrder?.CustomerSystemType !== SystemAccountType.WalkIn && (
              <Typography component='p' sx={{ display: 'inline-block' }}>
                <Box sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                  <AccountIcon accountType={WorkOrder.CustomerType || AccountType.Private} />
                </Box>
                <FullName
                  firstName={WorkOrder.CustomerFirstName || ''}
                  lastName={WorkOrder.CustomerName || ''}
                  prefix={WorkOrder.CustomerPrefix}
                />
              </Typography>
            )}
          </Box>
          <Box flex='1 1 auto' width='100%' display='flex' flexWrap='wrap' alignItems='center'>
            <Box display='inline-block'>
              {WorkOrder.VehicleManufacturer && (
                <Box display='inline-flex' alignContent='center' mr={1}>
                  <Icon className={`icon vehicle brand ${manufacturerToClass(WorkOrder.VehicleManufacturer)}`} fontSize='large' />
                </Box>
              )}
              {WorkOrder.VehicleRegistration && (
                <Box mr={1} display='inline-block'>
                  <LicensePlate registration={WorkOrder.VehicleRegistration} />
                </Box>
              )}
            </Box>
            <Box flex='1 1 auto' display='inline-block'>
              <Box display='inline-block'>
                <Typography variant='body2'>
                  {`${WorkOrder?.VehicleManufacturer} ${WorkOrder?.VehicleModel || ''} ${WorkOrder?.VehicleType || ''}`}
                </Typography>
                {WorkOrder.VehicleVIN ? <VinText value={WorkOrder.VehicleVIN} /> : null}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}
